
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/[slug]/about",
      function () {
        return require("private-next-pages/companies/[slug]/about/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/companies/[slug]/about"])
      });
    }
  